import { render, staticRenderFns } from "./RecommendationOrderHeader.vue?vue&type=template&id=a5815bfa"
import script from "./RecommendationOrderHeader.vue?vue&type=script&lang=js"
export * from "./RecommendationOrderHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports